const accountTypeMap = [
  { value: 'personalChecking', name: 'Personal Checking' },
  { value: 'personalSavings', name: 'Personal Savings' },
  { value: 'businessChecking', name: 'Business Checking' },
  { value: 'businessSavings', name: 'Business Savings' }
];
export default accountTypeMap;
